/* tslint:disable */
/* eslint-disable */
export enum CustomerOnlinePaymentStatusEnum {
  Pending = 'Pending',
  Success = 'Success',
  Cancelled = 'Cancelled',
  Error = 'Error'
}
